module.exports = __webpack_public_path__ + "static/media/step-solution2.e9f27822.svg";